import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';

@Component({
  selector: 'app-view-customer',
  templateUrl: './view-customer.component.html',
  styleUrls: ['./view-customer.component.scss'],
})
export class ViewCustomerComponent implements OnInit {
  editContacts: any = {};
  addresses: any = [];
  addressType: string;
  tabClicked = "address";
  addressTypes: any;

  constructor(private router: Router, public route: ActivatedRoute, private api: ApiIntegration, public user: User, private g: Globals) {
    this.g.loaderDisplay = "display";
    this.api.getAccountOwnerContacts(this.route.snapshot.params['id'], this.user.accountOwnerId, this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.editContacts = data;
      this.addresses = this.editContacts.addresses;
      this.addressType = this.editContacts.addressType;
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  editCustomers() {
    this.router.navigate(['/admin/editContacts/' + this.editContacts.accountOwnerContactId]);
  }

  ngOnInit() {
  }

  tabChange(tab) {
    this.tabClicked = tab
  }

}
